<script lang="ts">
  import { store } from '../lib/stores.svelte.js';
  import {
    fetchPrincipals, fetchProductTypes, fetchBrands, fetchSkus,
    type FilterOption,
  } from '../lib/queries.js';

  let principals     = $state<FilterOption[]>([]);
  let productTypes   = $state<FilterOption[]>([]);
  let brands         = $state<FilterOption[]>([]);
  let skus           = $state<{ sku_id: number; description: string }[]>([]);

  $effect(() => { fetchPrincipals().then((r) => (principals = r)).catch(() => {}); });
  $effect(() => {
    void store.principal;
    fetchProductTypes(store.principal).then((r) => (productTypes = r)).catch(() => {});
  });
  $effect(() => {
    void store.principal; void store.productType;
    fetchBrands(store.principal, store.productType).then((r) => (brands = r)).catch(() => {});
  });
  $effect(() => {
    void store.brand;
    fetchSkus(store.brand).then((r) => (skus = r)).catch(() => {});
  });
</script>

<div class="filter-row">
  <label>
    <span>Principal</span>
    <select value={store.principal} onchange={(e) => store.setPrincipal((e.currentTarget as HTMLSelectElement).value)}>
      <option value="">All principals</option>
      {#each principals as p (p.value)}
        <option value={p.value}>{p.value} ({p.count})</option>
      {/each}
    </select>
  </label>

  <label class:disabled={!store.principal}>
    <span>Product Type</span>
    <select value={store.productType} disabled={!store.principal}
            onchange={(e) => store.setProductType((e.currentTarget as HTMLSelectElement).value)}>
      <option value="">All product types</option>
      {#each productTypes as p (p.value)}
        <option value={p.value}>{p.value} ({p.count})</option>
      {/each}
    </select>
  </label>

  <label class:disabled={!store.principal}>
    <span>Brand</span>
    <select value={store.brand} disabled={!store.principal}
            onchange={(e) => store.setBrand((e.currentTarget as HTMLSelectElement).value)}>
      <option value="">All brands</option>
      {#each brands as b (b.value)}
        <option value={b.value}>{b.value} ({b.count})</option>
      {/each}
    </select>
  </label>

  <label class:disabled={!store.brand}>
    <span>SKU</span>
    <select value={store.sku_id ?? ''} disabled={!store.brand}
            onchange={(e) => {
              const v = (e.currentTarget as HTMLSelectElement).value;
              store.setSku(v ? Number(v) : null);
            }}>
      <option value="">All SKUs</option>
      {#each skus as s (s.sku_id)}
        <option value={s.sku_id}>{s.description}</option>
      {/each}
    </select>
  </label>
</div>

<style>
  .filter-row {
    display: flex;
    gap: var(--space-md);
    align-items: flex-end;
    flex-wrap: wrap;
  }
  label {
    display: flex;
    flex-direction: column;
    gap: var(--space-xs);
    font-family: var(--font-ui);
    font-size: var(--text-xs);
    font-weight: var(--weight-semibold);
    letter-spacing: var(--tracking-wide);
    text-transform: uppercase;
    color: var(--color-text-muted);
  }
  label.disabled { opacity: 0.5; }
  select {
    font-family: var(--font-ui);
    font-size: var(--text-sm);
    color: var(--color-text);
    background: var(--color-white);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    padding: 6px 10px;
    min-width: 180px;
    cursor: pointer;
  }
  select:disabled { cursor: not-allowed; background: var(--color-surface); }
  select:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
    border-color: var(--color-blue);
  }
</style>
